type UserMetadata = Record<string, unknown> | undefined | null;

function readNonEmptyString(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * Preferred public name — same priority as Account / Edit profile:
 * display_name → full_name → first + last → first_name.
 */
export function resolveUserDisplayName(metadata: UserMetadata): string {
  const display = readNonEmptyString(metadata?.display_name);
  if (display) return display;

  const full = readNonEmptyString(metadata?.full_name);
  if (full) return full;

  const first = readNonEmptyString(metadata?.first_name);
  const last = readNonEmptyString(metadata?.last_name);
  const combined = `${first} ${last}`.trim();
  if (combined) return combined;

  return first;
}

/** @deprecated Prefer resolveUserDisplayName — kept for call sites that want first only. */
export function resolveUserFirstName(metadata: UserMetadata): string {
  return readNonEmptyString(metadata?.first_name);
}

export function welcomeBackTitle(metadata: UserMetadata): string {
  const name = resolveUserDisplayName(metadata);
  return name ? `Welcome Back, ${name}.` : 'Welcome Back.';
}
